type RetryOptions = {
  retries: number;
  retryDelay: (attempt: number) => number;
};
/**
 * Generic retry function for any async operation
 */
export async function retryAsync<T>(
  fn: () => Promise<T>,
  options: {
    retries: number;
    retryDelay: (attempt: number) => number;
  }
): Promise<T> {
  for (let attempt = 0; attempt <= options.retries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      if (attempt === options.retries) {
        throw error; // Last attempt, re-throw the error
      }

      const delay = options.retryDelay(attempt);
      if (process.env.VERCEL_ENV !== "production") {
        console.log(`Attempt ${attempt + 1} failed, retrying in ${delay}ms...`);
      }
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
  // TypeScript requires this but it should never be reached
  throw new Error("Retry logic failed unexpectedly");
}
